import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Utils } from 'src/app/common/services/utils.service';
import { HttpRequestService } from 'src/app/common/services/http-request.service';
import { ShuttleModalService } from './shuttle-modal.service';
import { ShuttleRouteMasterService } from '../shuttle-route-master/shuttle-route-master.service';
import { RouteCreateService } from '../../route/route-create/route-create.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Validators } from '@angular/forms';
import { ShuttleTimeModalComponent } from '../shuttle-time-modal/shuttle-time-modal.component';

@Component({
  selector: 'app-shuttle-modal',
  templateUrl: './shuttle-modal.component.html',
  styleUrls: ['./shuttle-modal.component.css'],
  providers: [DialogService]
})
export class ShuttleModalComponent implements OnInit {

  shuttleTripRouteTableDatasource: object[];
  shuttleTripRouteTableConfigs: object;
  shuttleTripRouteTableColumnConfigs: any[];
  gridCallBacks: any = {};
  requestData: any;

  pivotFormTemplate: any[];
  pivotCreateConfig: any;
  comboSource: any[];

  isRouteSelected = false;
  isCalculate = false;
  viewSave = true;
  viewCalculate = true;
  @Output() displayChange = new EventEmitter();
  calculatedField: string = '';
  isFieldsValueChangedForCalc = false;

  constructor(public config: DynamicDialogConfig,
    private utils: Utils,
    private httpService: HttpRequestService,
    public ref: DynamicDialogRef,
    private shuttleModalService: ShuttleModalService,
    private routeCreateService: RouteCreateService,
    private dialogService: DialogService,
    private shuttleRouteMasterService: ShuttleRouteMasterService) { }

  fetchRequestDetails(selectedList) {
    if (selectedList.target === "ROUTE_CODE") {
      let reqData = {
        'strShuttleNo': selectedList.selectedItem.PPL_SHUTTLE_NO,
        'strTripNo': selectedList.selectedItem.TRIP_NO
      };
      this.requestData = this.utils.constructRequestData(reqData, 'PPLCorePassengerLogistics', selectedList.methodName);
    } else if (selectedList.target === "TRIP_NO") {
      let paxReqData = {
        'strTripNo': selectedList.selectedItem.TRIP_NO,
        'strType': 'Passenger'
      };
      this.requestData = this.utils.constructRequestData(paxReqData, 'CoreRequestService', selectedList.methodName);
    } else if (selectedList.target === "ROUTE_DETAILS") {
      let paxReqData = {
        'strShuttleNo': selectedList.selectedItem.PPL_SHUTTLE_NO,
        'strTripNo': '',
        'strRouteCode': selectedList.routeNo ? selectedList.routeNo : undefined
      };
      this.requestData = this.utils.constructRequestData(paxReqData, 'PPLCorePassengerLogistics', selectedList.methodName);
    }

    this.httpService.configRequestDataWithHeaders(this.requestData, 'post', '')
      .subscribe((response: any) => {
        let gridSource;
        this.comboSource = response['combo_array'];
        const hdrCache = response['hdrcache'][0];
        if (selectedList.target === 'ROUTE_CODE') {
          this.shuttleTripRouteTableConfigs = this.shuttleModalService.getShuttleSummaryTableConfigs();
          gridSource = this.utils.findAndSetGridSource(response['grid_array'], 'RoutePopUp');
          this.shuttleTripRouteTableColumnConfigs = this.shuttleModalService.getRouteTableColumnConfigs();
          this.utils.mapArrayToGridDropdowns(this.shuttleTripRouteTableColumnConfigs, this.comboSource, gridSource);

        } else if (selectedList.target === 'TRIP_NO') {
          this.shuttleTripRouteTableConfigs = this.shuttleModalService.getTripModalTableConfigs();
          gridSource = this.utils.findAndSetGridSource(response['grid_array'], 'Passengerpopupview');
          this.shuttleTripRouteTableColumnConfigs = this.shuttleModalService.getTripPaxTableColumnConfigs();
          let columnIds, columnTemp;
          if (this.shuttleTripRouteTableColumnConfigs && selectedList.isSelectedFromShuttle) {
            columnIds = ['PLANNED_PICK_TIME', 'PLANNED_DROP_TIME'];

            this.shuttleTripRouteTableColumnConfigs = this.shuttleTripRouteTableColumnConfigs.filter((elem) => {
              const item = columnIds.find(e => e === elem.id);
              return item ? false : true;
            });
          }
        } else if (selectedList.target === 'ROUTE_DETAILS') {
          this.isRouteSelected = true;

          this.shuttleTripRouteTableConfigs = this.shuttleModalService.getShuttleMappingTableConfigs();
          gridSource = this.utils.findAndSetGridSource(response['grid_array'], 'ShuttleRoutePopUp');
          this.shuttleTripRouteTableColumnConfigs = this.shuttleModalService.getRouteTableColumnConfigsInMapping();
          if (this.config.data.shuttleStatus === 'Active') {
            this.shuttleTripRouteTableConfigs['editable'] = false;
            this.viewCalculate = false;
            this.viewSave = false;
          }

          this.pivotFormTemplate = this.shuttleModalService.getPivotPointTemplate(this);

          const formConfig = this.shuttleModalService.modalFormConfig;
          this.utils.mapArrayToFormDropdowns(this.pivotFormTemplate, response['combo_array']);
          this.pivotFormTemplate[2].defaultValue = selectedList.selectedItem.pivotDetails;
          selectedList.selectedItem.strOrigin = selectedList.selectedItem.pivotDetails;
          selectedList.selectedItem.strPivotTime = selectedList.selectedItem.PIVOT_TIME;
          formConfig['formGroup'] = this.utils.constructFormControlGroup(this.pivotFormTemplate, selectedList.selectedItem, this.comboSource);
          this.pivotCreateConfig = formConfig;
        }
        this.utils.insertIdFieldInDataSource(gridSource);
        this.shuttleTripRouteTableDatasource = gridSource;

        if (selectedList.selectedItem.startTime || selectedList.selectedItem.dropTime || selectedList.selectedItem.PIVOT_POINT && (this.config.data.shuttleStatus != 'New') && (this.config.data.shuttleStatus != 'Active')) {
          setTimeout(() => {
            this.onClickCalculate();
          });
        }
      });
  }

  invokeApi(requestData, successCallback, failureCallback, scope, method?: string, id?: string) {
    const methodName = method ? method : 'post';
    this.httpService.configRequestDataWithHeaders(requestData, methodName, '')
      .subscribe((response => {
        successCallback(response, scope, id);
      }), failureCallback);
  }

  successOnSaveShtRouteInMapping(response, scope) {
    const gridSource = scope.utils.findAndSetGridSource(response['grid_array'], 'pivotShuttledetails');
    scope.utils.insertIdFieldInDataSource(gridSource, 'I');
    scope.gridCallBacks['scope'].dataset = gridSource;
    scope.gridCallBacks['scope'].dataViewObj.refresh();
    if (!scope.isCalculate) {
      scope.onCloseShuttleRouteModal(!scope.isCalculate);
    }
    scope.isCalculate = false;
  }

  successOnSaveTripRoute(response, scope) {
    const gridSource = scope.utils.findAndSetGridSource(response['grid_array'], 'pivotShuttleTrip');
    scope.utils.insertIdFieldInDataSource(gridSource, 'I');
    scope.utils.mapArrayToGridDropdowns(scope.shuttleTripRouteTableColumnConfigs, scope.comboSource, gridSource);
    scope.gridCallBacks['scope'].dataset = gridSource;
    scope.gridCallBacks['scope'].dataViewObj.refresh();
    scope.onCloseShuttleRouteModal();
  }

  onClickSave() {
    const formData = this.pivotCreateConfig['formGroup'].getRawValue();

    if ((!formData['strOrigin'] && !formData['strPivotTime']) && !formData['startTime'] && !formData['dropTime']) {
      this.utils.showNotification('Please select any of the fields in the form to calculate', 'error', 'Failure');
      return;
    }
    // if (this.isFieldsValueChangedForCalc) {
    //   this.utils.showNotification('Changed value must be calculated before save', 'error', 'Failure');
    //   return;
    // }
    if (formData['strPivotTime'] && !formData['strOrigin']) {
      this.utils.showNotification('Please select pivot point.', 'error', 'Failure');
      return;
    } else if (formData['strOrigin'] && !formData['strPivotTime']) {
      this.utils.showNotification('Please select pivot time.', 'error', 'Failure');
      return;
    }

    // if (!this.gridCallBacks.scope.dataset[0].PICK_TIME) {
    //   this.utils.showNotification('Please do calculate before save', 'error', 'Failure');
    //   return;
    // }
    const obj = {
      PIVOT_TIME: formData['strPivotTime'] ? this.utils.formatDate(formData['strPivotTime'], 'HH:mm') : '',
      PIVOT_POINT: formData['strOrigin'] ? formData['strOrigin'].value : '',
      SEQNO: formData['strOrigin'] ? formData['strOrigin'].seqno : '',
      START_TIME: formData['startTime'] ? this.utils.formatDate(formData['startTime'], 'HH:mm') : '',
      DROP_TIME: formData['dropTime'] ? this.utils.formatDate(formData['dropTime'], 'HH:mm') : '',
      startTime: formData['startTime'] ? this.utils.formatDate(formData['startTime'], 'HH:mm') : '',
      dropTime: formData['dropTime'] ? this.utils.formatDate(formData['dropTime'], 'HH:mm') : '',
      pivotDetails: formData['strOrigin'],
      calculatedField: this.calculatedField
    };
    this.ref.close(obj);
  }

  onClickCalculate() {
    const formData = this.pivotCreateConfig ? this.pivotCreateConfig['formGroup'].getRawValue() : '';
    if ((!formData['strOrigin'] && !formData['strPivotTime']) && !formData['startTime'] && !formData['dropTime']) {
      this.utils.showNotification('Please select any of the fields in the form to calculate', 'error', 'Failure');
      return;
    }
    if (formData['strPivotTime'] && !formData['strOrigin']) {
      this.utils.showNotification('Please select pivot point.', 'error', 'Failure');
      return;
    } else if (formData['strOrigin'] && !formData['strPivotTime']) {
      this.utils.showNotification('Please select pivot time.', 'error', 'Failure');
      return;
    }
    this.isCalculate = true;
    this.isFieldsValueChangedForCalc = false;
    const methodName = this.isCalculate ? 'saveCalcPivotSht' : 'savePivotLogisticsSht';
    const selectedItem = this.config.data.selectedItem;
    const isShuttleRoute = this.config.data.isShuttleRoute;
    if (this.isCalculate || isShuttleRoute) {
      const extendedData = {
        'strShuttleNo': selectedItem.PPL_SHUTTLE_NO,
        'strLocCode': formData['strOrigin'] && formData['strOrigin'].id ? formData['strOrigin'].id : '',
        'strPivotTime': formData['strPivotTime'] ? this.utils.formatDate(formData['strPivotTime'], 'HH:mm') : '',
        'SeqNo': formData['strOrigin'] ? formData['strOrigin'].seqno : '',
        'PassengerShtRt_array': this.gridCallBacks['scope'].dataset,
        'strStartTime': formData['startTime'] ? this.utils.formatDate(formData['startTime'], 'HH:mm') : '',
        'strEndTime': formData['dropTime'] ? this.utils.formatDate(formData['dropTime'], 'HH:mm') : ''
      };
      const requestParam = this.utils.constructRequestData(extendedData, 'PPLCorePassengerLogistics', methodName);
      this.invokeApi(requestParam, this.successOnSaveShtRouteInMapping, '', this);

    } else if (isShuttleRoute === false) {
      const gridSource = this.gridCallBacks['scope'].dataset;
      const reqData = {
        'strTripNo': selectedItem.TRIP_NO,
        'PassengerShtRt_array': this.utils.constructRequestDataGridArray(gridSource)
      }
      const requestParam = this.utils.constructRequestData(reqData, 'PPLCorePassengerLogistics', 'savePivotTripSht');
      this.invokeApi(requestParam, this.successOnSaveTripRoute, '', this);
    }
  }

  onSelectPivotPoint(item, scope, id) {
    let pivotLoc = item ? item.value : '';
    if (!!pivotLoc) {
      scope.pivotCreateConfig['formGroup'].controls['strPivotTime'].setValidators(pivotLoc ? [Validators.required] : []);
      scope.pivotCreateConfig['formGroup'].controls['strPivotTime'].updateValueAndValidity();
    }
    scope.pivotFormTemplate[3]['showAsterisk'] = !!pivotLoc ? true : false;
    scope.pivotCreateConfig.formGroup.controls['dropTime'].patchValue(null);
    scope.pivotCreateConfig.formGroup.controls['startTime'].patchValue(null);
    scope.calculatedField = item ? (item.value ? 'pivot' : '') : scope.calculatedField;
    scope.isFieldsValueChangedForCalc = true;
  }

  onCellClickOnShuttleModal(event) {
    const scope = this;
    const elemId = event.element.target.id;
    const target = event.element.target;
    const splitId = elemId.split('-');

    const selectedRowDetails = scope.gridCallBacks['scope'].dataset.find(e =>
      e.TRIP_NO === splitId[1]
    );
    if (target.tagName === 'I' && splitId[0] === 'del_leg') {
      scope.onDelete();
    }
  }

  onDelete() {
    const selectedItem = this.gridCallBacks['getSelectedRows'](this.gridCallBacks['scope']);
    const reqData = {
      'strTripNo': selectedItem[0].TRIP_NO,
    }
    let methodName, reqParamsData;
    if (!reqData.strTripNo) {
      methodName = 'requestreportpopupfun';
      reqParamsData = {
        'strTripNo': this.config.data.selectedItem.TRIP_NO,
      };
    } else {
      methodName = 'deleteLocTripSht';
      reqParamsData = {
        'strTripNo': selectedItem[0].TRIP_NO,
        'SeqNo': selectedItem[0].ROUTE_DTL_SEQ_NO,
        'strLocCode': selectedItem[0].ROUTE_CODE ? selectedItem[0].ROUTE_CODE.value : '',
      };
    }
    const requestParam = this.utils.constructRequestData(reqParamsData, 'PPLCorePassengerLogistics', methodName);
    this.invokeApi(requestParam, this.successOnDelRoute, '', this);
  }

  successOnDelRoute(response, scope) {
    let gridSource;
    const pivotGrid = scope.utils.findAndSetGridSource(response['grid_array'], 'pivotShuttleTrip');
    const routeGrid = scope.utils.findAndSetGridSource(response['grid_array'], 'RoutePopUp');
    gridSource = pivotGrid ? pivotGrid : routeGrid;
    scope.utils.insertIdFieldInDataSource(gridSource);
    scope.utils.mapArrayToGridDropdowns(scope.shuttleTripRouteTableColumnConfigs, scope.comboSource, gridSource);
    scope.gridCallBacks['scope'].dataset = gridSource;
    scope.gridCallBacks['scope'].dataViewObj.refresh();
  }

  onTripAmend() {
    let modalData = {
      'selectedItem': this.config.data.selectedItem,
      'PassengerShtRt_array': this.gridCallBacks['scope'].dataset
    }
    const ref = this.dialogService.open(ShuttleTimeModalComponent, {
      data: { modalData },
      header: 'Route Effective Time',
      width: '30%',
      contentStyle: { "height": "90px", "overflow": "hidden" },
    });

    ref.onClose.subscribe((response) => {

    });
  }

  onCloseShuttleRouteModal(isSave: boolean) { 
    this.ref.close(isSave);
    this.displayChange.emit(isSave);
  }

  onSelectDate(formatedDateString, dateObj, scope, id) {
    if (id === 'startTime') {
      scope.pivotCreateConfig.formGroup.controls['dropTime'].patchValue(null);
      scope.pivotCreateConfig.formGroup.controls['strPivotTime'].patchValue(null);
      scope.pivotCreateConfig.formGroup.controls['strOrigin'].patchValue(null);
      scope.pivotFormTemplate[2]['showAsterisk'] = false;
      scope.pivotFormTemplate[3]['showAsterisk'] = false;
    } else if (id === 'dropTime') {
      scope.pivotCreateConfig.formGroup.controls['startTime'].patchValue(null);
      scope.pivotCreateConfig.formGroup.controls['strPivotTime'].patchValue(null);
      scope.pivotCreateConfig.formGroup.controls['strOrigin'].patchValue(null);
      scope.pivotFormTemplate[2]['showAsterisk'] = false;
      scope.pivotFormTemplate[3]['showAsterisk'] = false;
    } else if (id === 'strPivotTime') {
      scope.pivotCreateConfig.formGroup.controls['dropTime'].patchValue(null);
      scope.pivotCreateConfig.formGroup.controls['startTime'].patchValue(null);
      scope.pivotCreateConfig['formGroup'].controls['strOrigin'].setValidators([Validators.required]);
      scope.pivotCreateConfig['formGroup'].controls['strPivotTime'].updateValueAndValidity();
      scope.pivotFormTemplate[2]['showAsterisk'] = true;
    }
    scope.calculatedField = ((id === 'startTime') ? 'start' : (id === 'dropTime' ? 'drop' : 'pivot'));
    scope.isFieldsValueChangedForCalc = true;
  }

  ngOnInit() {
    this.fetchRequestDetails(this.config.data);
  }

}

